var _defs, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationSetupBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.61002,
    height: 15.865726,
    viewBox: "0 0 19.61002 15.865727",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#2f92d0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    id: "g2",
    transform: "translate(-0.31322587,-2.3177865)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.3244367,
    cy: 5.8354859,
    id: "circle1",
    rx: 2.93273,
    ry: 2.8605494,
    style: {
      strokeWidth: 1.3143,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5.4151716,10.493731 c -2.4031429,0 -4.3693507,1.507392 -4.3693507,3.478594 v 3.478594 h 8.7387015 v -3.478594 c 0,-1.971202 -1.9662082,-3.478594 -4.3693508,-3.478594 z",
    id: "path1",
    style: {
      strokeWidth: 1.46519,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#2f92d0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "matrix(0.47854538,0,0,0.47647061,10.833424,8.2728988)",
    id: "g2-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 17.76057,9.1556909 c 0,-0.8833454 -0.708248,-1.5996233 -1.582641,-1.5996233 H 15.180115 A 6.3039828,6.3754494 0 0 0 14.506044,5.9093965 L 15.211445,5.195039 A 1.5819742,1.5999087 0 1 0 12.973721,2.9329066 L 12.26832,3.646304 A 6.3039828,6.3754494 0 0 0 10.640108,2.9645918 V 1.9545056 a 1.5826415,1.6005835 0 0 0 -3.1643339,0 V 2.9645918 A 6.3039828,6.3754494 0 0 0 5.8475617,3.646304 L 5.1412118,2.9329066 A 1.5816921,1.5996233 0 1 0 2.9044372,5.195039 L 3.6098377,5.9093965 A 6.3039828,6.3754494 0 0 0 2.9357672,7.5560676 H 1.9370037 a 1.5826415,1.6005835 0 0 0 0,3.2002064 h 0.9987635 a 6.3039828,6.3754494 0 0 0 0.6740705,1.646671 l -0.7054005,0.713398 a 1.5819742,1.5999087 0 1 0 2.2367746,2.263092 l 0.7063499,-0.713397 c 0.50223,0.299569 1.0490815,0.530007 1.6282124,0.681712 v 1.009126 a 1.5826415,1.6005835 0 0 0 3.1643339,0 V 15.34775 a 6.3039828,6.3754494 0 0 0 1.628212,-0.681712 l 0.705401,0.713397 a 1.5823098,1.6002481 0 1 0 2.237724,-2.263092 l -0.705401,-0.713398 c 0.296211,-0.508883 0.524066,-1.060974 0.674071,-1.646671 h 0.997814 c 0.873443,0 1.582641,-0.716278 1.582641,-1.6005831 z",
    id: "path1-5",
    style: {
      strokeWidth: 2.46824,
      strokeDasharray: "none"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.0564337,
    cy: 9.2625179,
    r: 2.5,
    id: "circle1-5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationSetupBlue);
export default __webpack_public_path__ + "static/media/operation-setup-blue.0bf46189a070dbc991921c8e9fd13c9a.svg";
export { ForwardRef as ReactComponent };